export default __webpack_public_path__ + "static/media/italian-overload.ed8f42ab.png";